import React, { useState } from 'react';
import UserPill from './UserPill';

export default function AssignmentBox({
  label,
  selectedIds = [],
  users = [],
  isEditing = false,
  onAdd,
  onRemove,
  emptyPlaceholder = "None assigned",
  addPlaceholder = "-- Add --",
  excludeIds = []
}) {
  const [localInput, setLocalInput] = useState('');

  // Normalize selectedIds to support both array and comma-separated strings (for RoomAssignments)
  const idArray = Array.isArray(selectedIds)
    ? selectedIds
    : (selectedIds ? selectedIds.split(/[,/&]/).map(n => n.trim()).filter(Boolean) : []);

  const handleAddClick = () => {
    if (localInput) {
      onAdd(localInput);
      setLocalInput('');
    }
  };

  const available = users.filter(u =>
    !idArray.includes(u.id) &&
    !idArray.includes(u.name) &&
    !excludeIds.includes(u.id)
  );

  return (
    <div
      className="room-assignment-box"
      style={{
        background: 'var(--color-room-box-bg)',
        borderRadius: '6px',
        padding: '6px',
        border: '1px solid var(--color-room-box-border)',
        marginTop: '2px'
      }}
    >
      {label && (
        <span
          style={{
            display: 'block',
            fontSize: '0.6rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: 'var(--color-primary)',
            fontWeight: '600',
            marginBottom: '5px'
          }}
        >
          {label}
        </span>
      )}

      {idArray.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: (isEditing && available.length > 0) ? '8px' : '0' }}>
          {idArray.map(id => (
            <UserPill
              key={id}
              id={id}
              users={users}
              onRemove={isEditing ? () => onRemove(id) : null}
            />
          ))}
        </div>
      ) : (
        <div style={{ marginBottom: (isEditing && available.length > 0) ? '8px' : '0' }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontStyle: 'italic' }}>
            {emptyPlaceholder}
          </span>
        </div>
      )}

      {isEditing && available.length > 0 && (
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <select
            className="room-occupant-input"
            value={localInput}
            onChange={e => setLocalInput(e.target.value)}
            style={{
              flex: 1,
              background: 'rgba(0,0,0,0.2)',
              border: '1px solid var(--color-room-box-border)',
              borderRadius: '4px',
              color: 'var(--color-text-main)',
              padding: '3px 6px',
              fontSize: '0.78rem',
              outline: 'none',
              cursor: 'pointer'
            }}
          >
            <option value="" style={{ background: '#1e293b', color: '#94a3b8' }}>
              {addPlaceholder}
            </option>
            {available.map(u => (
              <option key={u.id} value={u.id} style={{ background: '#1e293b', color: 'var(--color-text-main)' }}>
                {u.name}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="btn-secondary"
            style={{
              padding: '3px 10px',
              fontSize: '0.75rem',
              borderRadius: '4px',
              whiteSpace: 'nowrap'
            }}
            onClick={handleAddClick}
          >
            + Add
          </button>
        </div>
      )}
    </div>
  );
}
